// src/lib/kinema/konva/renderers/TextRenderer.ts
import Konva from 'konva';
import type { KonvaRenderer } from './types';
import type { BaseLayerData } from '../../core/types';

function computeKonvaFontStyle(layer: BaseLayerData): string {
  const bold = layer.fontWeight >= 700;
  const italic = layer.fontStyle === 'italic';
  if (bold && italic) return 'italic bold';
  if (bold) return 'bold';
  if (italic) return 'italic';
  return 'normal';
}

export const TextRenderer: KonvaRenderer = {
  create(layer: BaseLayerData): Konva.Node {
    return new Konva.Text({
      text: layer.text,
      fontFamily: layer.fontFamily,
      fontSize: layer.fontSize,
      fontStyle: computeKonvaFontStyle(layer),
      fill: layer.color,
      align: layer.textAlign,
      verticalAlign: layer.verticalAlign ?? 'top',
      width: layer.width,
      height: layer.height,
      lineHeight: layer.lineHeight,
      wrap: 'word',
    });
  },
  update(node: Konva.Node, layer: BaseLayerData, changed: Record<string, boolean>): void {
    const textNode = node as Konva.Text;
    if (changed.text) textNode.text(layer.text);
    if (changed.fontFamily) textNode.fontFamily(layer.fontFamily);
    if (changed.fontSize) textNode.fontSize(layer.fontSize);
    if (changed.fontWeight || changed.fontStyle) textNode.fontStyle(computeKonvaFontStyle(layer));
    if (changed.color) textNode.fill(layer.color);
    if (changed.textAlign) textNode.align(layer.textAlign);
    if (changed.verticalAlign) textNode.verticalAlign(layer.verticalAlign ?? 'top');
    if (changed.width) textNode.width(layer.width);
    if (changed.height) textNode.height(layer.height);
    if (changed.lineHeight) textNode.lineHeight(layer.lineHeight);
  },
  destroy(node: Konva.Node): void { node.destroy(); },
};
